import { instance4, WMS_FA_INPUT } from "App/constants";
import { defaultToastError, formatNumber, isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useState, useRef } from "react";
import { RESET_STATE_DATA_FIXED_ASSET } from "../helpers";
import { urlGetFile } from "../ui/TabFile/helpers";
import {
  RESET_STATE_INPUT_FIXED_ASSET,
  urlGetAsset,
} from "../ui/TabFixedAsset/helpers";
import { urlGetHistory } from "../ui/TabHistory/helpers";
import { urlPembayaran } from "../ui/TabPembayaran/helpers";
import { urlGetPenyusutan } from "../ui/TabPenyusutan/helpers";
export const FormContext = createContext();

export const FormProvider = ({ menu, data, children }) => {
  const oldHeadData = useRef(null);
  const [headData, setHeadData] = useState(() => {
    if (isNull(data)) {
      return RESET_STATE_DATA_FIXED_ASSET;
    } else {
      if (menu === WMS_FA_INPUT) {
        oldHeadData.current = data;
        return data;
      } else {
        if (isNull(oldHeadData.current)) {
          return RESET_STATE_DATA_FIXED_ASSET;
        } else {
          return oldHeadData.current;
        }
      }
    }
  });

  const oldFormData = useRef(null);
  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return RESET_STATE_INPUT_FIXED_ASSET;
    } else {
      if (menu === WMS_FA_INPUT) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return RESET_STATE_INPUT_FIXED_ASSET;
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  useEffect(() => {
    if (isNull(data)) {
      setHeadData(RESET_STATE_DATA_FIXED_ASSET);
    } else {
      if (menu === WMS_FA_INPUT) {
        oldFormData.current = data;
        setHeadData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setHeadData(RESET_STATE_DATA_FIXED_ASSET);
        } else {
          setHeadData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line

  useEffect(() => {
    if (isNull(data)) {
      setFormData(RESET_STATE_INPUT_FIXED_ASSET);
    } else {
      if (menu === WMS_FA_INPUT) {
        oldFormData.current = data;
        fetchAll(data.id, data.id_pembelian);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData(RESET_STATE_INPUT_FIXED_ASSET);
          setDataHistory([]);
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line

  const [dataPembayaran, setDataPembayaran] = useState([]);
  const [dataHistory, setDataHistory] = useState([]);
  const [dataPenyusutan, setDataPenyusutan] = useState([]);
  const [dataFile, setDataFile] = useState([]);
  const [dataKalibrasi, setDataKalibrasi] = useState([]);
  const [dataMaintenance, setDataMaintenance] = useState([]);

  const fetchAll = async (ID, ID_PEMBELIAN) => {
    const fetchDataAsset = instance4.get(`${urlGetAsset}/${ID}`);
    const fetchDataHistory = instance4.get(`${urlGetHistory}/${ID}`);
    const fetchDataPenyusutan = instance4.get(`${urlGetPenyusutan}/${ID}`);
    const fetchDataPembayaran = instance4.get(`${urlPembayaran}/${ID_PEMBELIAN}`);
    const fetchDataFile = instance4.get(`${urlGetFile}/${ID}`);
    Promise.all([fetchDataAsset, fetchDataHistory, fetchDataPenyusutan, fetchDataPembayaran, fetchDataFile]).then(
      (response) => {
        const responseDataAsset = response[0].data;
        const responseDataHistory = response[1].data;
        const responseDataPenyusutan = response[2].data;
        const responseDataPembayaran = response[3].data;
        const responseDataFile = response[4].data;

        // Data Asset
        if (responseDataAsset.status === 200) {
          setFormData({
            ...responseDataAsset.body[0],
            harga_perolehan2: formatNumber(
              responseDataAsset.body[0]?.harga_perolehan
            ),
            nilai_aset2: formatNumber(responseDataAsset.body[0]?.nilai_aset),
            nilai_sisaditaksir2: formatNumber(
              responseDataAsset.body[0]?.nilai_sisaditaksir
            ),
            produsen: isNull(responseDataAsset.body[0]?.produsen) ? "Pilih Produsen" : responseDataAsset.body[0]?.produsen,
            nama_typeasset: isNull(responseDataAsset.body[0]?.nama_typeasset) ? "Pilih Tipe Fixed Asset" : responseDataAsset.body[0]?.nama_typeasset,
            nama_fiscal: isNull(responseDataAsset.body[0]?.nama_fiscal) ? "Pilih Fiscal" : responseDataAsset.body[0]?.nama_fiscal,
            coa_fixassets: isNull(responseDataAsset.body[0]?.coa_fixassets) ? "Pilih COA" : responseDataAsset.body[0]?.coa_fixassets,
            coa_akumulasi: isNull(responseDataAsset.body[0]?.coa_akumulasi) ? "Pilih COA" : responseDataAsset.body[0]?.coa_akumulasi,
            coa_bebanpenyusutan: isNull(responseDataAsset.body[0]?.coa_bebanpenyusutan) ? "Pilih COA" : responseDataAsset.body[0]?.coa_bebanpenyusutan,
          });
        } else {
          setFormData(RESET_STATE_INPUT_FIXED_ASSET);
          defaultToastError(responseDataAsset.message);
        }

      // Data History
      if (responseDataHistory.status === 200) {
        setDataHistory(responseDataHistory.body);
      } else {
        setDataHistory([]);
        defaultToastError(responseDataHistory.message);
      }

      // Data Penyusutan
      if (responseDataPenyusutan.status === 200) {
        setDataPenyusutan(responseDataPenyusutan.body);
      } else {
        setDataPenyusutan([]);
        defaultToastError(responseDataPenyusutan.message);
      }

        // Data Pembayaran
        if (responseDataPembayaran.status === 200) {
          setDataPembayaran(responseDataPembayaran.data);
        } else {
          setDataPembayaran([]);
          defaultToastError(responseDataPembayaran.message);
        }

        // Data File
        if (responseDataFile.status === 200) {
          setDataFile(responseDataFile.body);
        } else {
          setDataFile([]);
          defaultToastError(responseDataFile.message);
        }
      }
    );
  };

  const [disabledInput, setDisabledInput] = useState(false);

  useEffect(() => {
    setDisabledInput(false);
  }, [data]);

  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        headData,
        setHeadData,
        dataHistory,
        setDataHistory,
        dataPenyusutan,
        setDataPenyusutan,
        dataPembayaran,
        setDataPembayaran,
        dataFile,
        setDataFile,
        disabledInput,
        setDisabledInput,
        dataKalibrasi,
        setDataKalibrasi,
        dataMaintenance,
        setDataMaintenance,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
